import React, { FC } from 'react';

import { useTranslate } from '@/hooks/use-translate';

import { en } from '../en';

import styles from './HeaderSection.module.scss';

export const HeaderSection: FC = () => {
	const t = useTranslate(en);

	return (
		<div className={styles.headerWrapper}>
			<header className={styles.header}>
				<h1 className={styles.title}>{t('Справочный центр')}</h1>
			</header>
		</div>
	);
};
